import { createAction, handleActions } from 'redux-actions';

const setSelectedItemDescriptionId = createAction("SCREENS/ITEM_DESCRIPTIONS/SET_SELECTED_ITEM_DESCRIPTION_ID");

const defaultState = null;

const reducer = handleActions(
  {
    [setSelectedItemDescriptionId]: (state, action) => action.payload
  },
  defaultState
);

export { setSelectedItemDescriptionId, reducer };
